import {
    FETCH_PROJECTS_HOME
} from '../actions/types'

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_PROJECTS_HOME:
            return action.payload
        default:
            return state
    }
}